/* Black Marlin Trading Company — Theme JS */

(function () {
  'use strict';

  /* ── Mobile Navigation ─────────────────────────────────── */
  const navToggle = document.querySelector('.mobile-nav-toggle');
  const siteNav   = document.querySelector('.site-nav');

  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function () {
      const isOpen = siteNav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', String(isOpen));
      navToggle.textContent = isOpen ? '✕' : '☰';
    });
  }

  /* ── Cart Count Badge ──────────────────────────────────── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const badges = document.querySelectorAll('.cart-count');
        badges.forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.dataset.count = cart.item_count;
        });
      })
      .catch(function () {});
  }

  updateCartCount();

  /* ── Product Quantity Stepper ──────────────────────────── */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-form__qty-btn');
    if (!btn) return;

    const input = btn.closest('.product-form__qty').querySelector('.product-form__qty-input');
    const delta = btn.dataset.action === 'plus' ? 1 : -1;
    const next  = Math.max(1, parseInt(input.value, 10) + delta);
    input.value = next;
  });

  /* ── Gallery Thumbnails ────────────────────────────────── */
  document.addEventListener('click', function (e) {
    const thumb = e.target.closest('.product-gallery__thumb');
    if (!thumb) return;

    const gallery = thumb.closest('.product-gallery');
    if (!gallery) return;

    const main = gallery.querySelector('.product-gallery__main img');
    if (main) {
      main.src = thumb.dataset.src || thumb.querySelector('img').src;
    }

    gallery.querySelectorAll('.product-gallery__thumb').forEach(function (t) {
      t.classList.remove('active');
    });
    thumb.classList.add('active');
  });

  /* ── Cart Item Remove ──────────────────────────────────── */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.cart-item__remove');
    if (!btn) return;

    const key = btn.dataset.key;
    if (!key) return;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    })
      .then(function () { window.location.reload(); })
      .catch(function () {});
  });

  /* ── Email Signup (Shopify Customer Newsletter) ─────────── */
  const signupForm = document.querySelector('.email-signup__form');
  if (signupForm) {
    signupForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const input  = signupForm.querySelector('.email-signup__input');
      const btn    = signupForm.querySelector('.email-signup__btn');
      const email  = input ? input.value.trim() : '';

      if (!email) return;

      btn.disabled    = true;
      btn.textContent = 'Joining...';

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          form_type: 'customer',
          utf8:      '✓',
          'contact[email]': email,
          'contact[tags]':  'newsletter',
        }),
      })
        .then(function () {
          btn.textContent  = 'You\'re In! ✓';
          input.value      = '';
        })
        .catch(function () {
          btn.disabled    = false;
          btn.textContent = 'Sign Me Up';
        });
    });
  }

  /* ── Sticky header shadow on scroll ───────────────────── */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

})();
